var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 90 90"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillOpacity: 0.7,
    d: "M18.75 78.75q-3.094 0-5.299-2.205-2.204-2.205-2.201-5.295V21.844l-6-6.094q-1.032-1.03-1.08-2.58-.05-1.549 1.08-2.67 1.03-1.03 2.625-1.031 1.593 0 2.625 1.031l69 69q1.125 1.125 1.08 2.625t-1.174 2.625q-1.125 1.031-2.625 1.08-1.5.048-2.625-1.08l-6-6zm0-7.5h41.906l-7.5-7.5H26.25q-1.125 0-1.687-1.031-.563-1.032.187-1.969l7.5-9.937q.563-.75 1.5-.75t1.5.75l6 8.156 3.188-3.938L18.75 29.344zm60-3.094-7.5-7.5V18.75H29.344l-7.5-7.5H71.25q3.094 0 5.299 2.205 2.204 2.205 2.201 5.295z"
  })));
};
export default SvgNoImage;